export default __webpack_public_path__ + "static/media/ic_deskera_app.60e98f3f.png";